import React, { useEffect } from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import ButtonTabs from "../../Components/ButtonTabs/ButtonTabs";
import PersonalDetails from "../MemberRegistration/PersonalDetails";
import WitnessDetails from "../MemberRegistration/WitnessDetails";
import EmployeeDetails from "../MemberRegistration/EmployeeDetails";
import NomineeDetails from "../MemberRegistration/NomineeDetails";
import "./MemberDetails.css";
import { ApplicationStatus } from "../../Helpers/Enums/ApplicationStatus";
import { getMemberRegistrationStatusByMemberId } from "../../Helpers/APIEndPoints/EndPoints";
import { APICall } from "../../Helpers/Network/APICalls";
import { useLocation } from "react-router-dom";
import { Decrypt } from "../../Helpers/Cryptography/Crypto";
import { GetDecryptedMemberIdFromLocalStorage } from "../../Helpers/CommonFunctions/EncryptedMemberIdFunction";
interface TabPanelProps {
  children?: React.ReactNode;
  index: number;
  value: number;
}

function CustomTabPanel(props: TabPanelProps) {
  const { children, value, index, ...other } = props;

  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`simple-tabpanel-${index}`}
      aria-labelledby={`simple-tab-${index}`}
      aria-disabled={false}
      {...other}
    >
      {value === index && (
        <Box sx={{ p: 3 }}>
          <Typography component="div">{children}</Typography>
        </Box>
      )}
    </div>
  );
}

function a11yProps(index: number) {
  return {
    id: `simple-tab-${index}`,
    "aria-controls": `simple-tabpanel-${index}`,
  };
}

const MemberDetails = (props) => {
  const { state } = useLocation();
  const [value, setValue] = React.useState(0);
  const [visible, setVisible] = React.useState(true);
  const [tabsStatus, setTabsStatus] = React.useState([
    false,
    false,
    false,
    false,
  ]);
  const [previous, setPrevious] = React.useState(false);
  const memberid =
    GetDecryptedMemberIdFromLocalStorage() || state?.MemberId || "";
  const [statusData, setStatusData] = React.useState(props?.statusData);
  useEffect(() => {
    activeStep();
    getMemberIdStatusDetails();
  }, []);

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setValue(newValue);
    // setTabsStatus((prevStatus) => prevStatus.map((_, index) => index <= newValue));
  };

  const { previousTab, next } = props;
  const selectNextTab = (index: any) => {
    getMemberIdStatusDetails().finally(() => {
      let val = value + 1;
      setValue(val);
      // index === val   && setVisible(false)
      //  index == 1 ? setTabsStatus([false,false,true,true]) : index == 2 ? setTabsStatus([false,false,false,true]) : setTabsStatus([true,true,true,true])
      setTabsStatus((prevStatus) =>
        prevStatus.map((d, i) => (i <= index ? (d = false) : (d = true)))
      );
    });
  };

  const selectPreviousTab = (index: any) => {
    setValue(value - 1);

    setTabsStatus((prevStatus) =>
      prevStatus.map((d, i) => (i <= index ? (d = false) : (d = true)))
    );
  };

  const enablStepStatus = (id) => {
    if (id) {
      let tempData = tabsStatus.map((ss, index) => {
        if (index <= id) {
          return false;
        } else {
          return true;
        }
      });
      setTabsStatus(tempData);
    }
  };

  const activeStep = () => {
    if (
      state?.IsMemberWitnessDetail == false &&
      state?.IsMemberPersonalDetail == true
    ) {
      setValue(1);
      setTabsStatus([true, false, false, false]);
    } else if (state?.IsMemberEmployementDetail === false) {
      setValue(2);
      setTabsStatus([true, true, false, false]);
    } else if (state?.IsMemberNomineeDetail == false) {
      setValue(3);
      setTabsStatus([true, true, true, false]);
    }
  };
  const getMemberIdStatusDetails = async () => {
    let url = `${getMemberRegistrationStatusByMemberId}`;
    let requestBody = { MemberId: memberid };

    const getData = await APICall(url, requestBody);
    setStatusData(getData?.Data);
    if (getData?.Data != null) {
      const statusId = getData.Data.StatusId;
      const IsMemberPersonalDetailsExists =
        getData.Data.IsMemberPersonalDetailsExists;
      const IsMemberWitnessDetailsExists =
        getData.Data.IsMemberWitnessDetailsExists;
      const IsMemberEmploymentDetailsExists =
        getData.Data.IsMemberEmploymentDetailsExists;
      const IsMemberNomineeDetailsExists =
        getData.Data.IsMemberNomineeDetailsExists;

      if (statusId) {
        if (
          [
            ApplicationStatus.MemberRegistrationModule_Draft,
            ApplicationStatus.MemberRegistrationModule_PendingWithHRHOD,
            ApplicationStatus.MemberRegistrationModule_RejectedHRHOD,
          ].includes(statusId)
        ) {
          if (ApplicationStatus.MemberRegistrationModule_Draft) {
            if (
              IsMemberNomineeDetailsExists ||
              IsMemberEmploymentDetailsExists
            ) {
              enablStepStatus(3);
            } else if (IsMemberWitnessDetailsExists) {
              enablStepStatus(2);
            } else if (IsMemberPersonalDetailsExists) {
              enablStepStatus(1);
            } else {
              enablStepStatus(0);
            }
          } else {
            enablStepStatus(3);
          }
        } else if (
          [
            ApplicationStatus.MemberRegistrationModule_PendingWithInternalTeam,
            ApplicationStatus.MemberRegistrationModule_RejectedByInternalTeam,
            ApplicationStatus.MemberRegistrationModule_PendingWithMemberForPaymentDetails,
            ApplicationStatus.MemberRegistrationModule_PendingWithEnrollmentCommittee,
          ].includes(statusId)
        ) {
          enablStepStatus(3);
        } else {
          enablStepStatus(3);
        }
      }
    }
  };

  const tabs = [
    {
      label: "Personal Details",
      value: { ...a11yProps(0) },
      disabled: tabsStatus[0],
    },
    {
      label: "Witness Details",
      value: { ...a11yProps(1) },
      disabled: tabsStatus[1],
    },
    {
      label: "Employee Details",
      value: { ...a11yProps(2) },
      disabled: tabsStatus[2],
    },
    {
      label: "Nominee Details",
      value: { ...a11yProps(3) },
      disabled: tabsStatus[3],
    },
  ];

  const enableTabs = (id) => {
  
    if (id) {
      let tempData = tabsStatus.map((ts, i) => id.includes(i));

      setTabsStatus(tempData);
    }
  };

  return (
    <Box sx={{ width: "100%" }}>
      <ButtonTabs value={value} handleChange={handleChange} tabs={tabs} />

      <CustomTabPanel value={value} index={0}>
        <PersonalDetails
          selectNextTab={(index) => selectNextTab(1)}
          selectPreviousTab={selectPreviousTab}
          statusData={statusData}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={1}>
        <WitnessDetails
          selectNextTab={() => selectNextTab(2)}
          selectPreviousTab={(index) => selectPreviousTab(1)}
          statusData={statusData}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={2}>
        <EmployeeDetails
          selectNextTab={() => selectNextTab(3)}
          selectPreviousTab={(index) => selectPreviousTab(2)}
          statusData={statusData}
        />
      </CustomTabPanel>
      <CustomTabPanel value={value} index={3}>
        <NomineeDetails
          selectNextTab={async () => await next()}
          selectPreviousTab={(index) => selectPreviousTab(3)}
          statusData={statusData}
        />
      </CustomTabPanel>
    </Box>
  );
};

export default MemberDetails;
